import { FC } from 'react'
import { EntityPicker, EntityItem } from '../entity-picker'
import { useCostCenters } from '@hooks/useCostCenters'
import { useTranslation } from 'react-i18next'

interface Props {
  columnNameTranslationKey: TranslationKey
  onChange: (ids: Set<string>) => void
  selectedIds: Set<string>
}
export const WorkdayCostCenterPicker: FC<Props> = ({
  columnNameTranslationKey,
  onChange,
  selectedIds,
}) => {
  const { t } = useTranslation()

  return (
    <EntityPicker
      className="w-72"
      columnNameTranslationKey={columnNameTranslationKey}
      filter={(costCenter, search) => {
        return costCenter.name.toLowerCase().includes(search.toLowerCase())
      }}
      placeholder={t('common.search')}
      isSelected={(costCenter, selectedIds) => selectedIds.has(costCenter.id)}
      renderSearchItem={(costCenter) => (
        <EntityItem
          key={costCenter.id}
          onClick={() => onChange(new Set(selectedIds).add(costCenter.id))}
          primaryText={costCenter.name}
          disabled={selectedIds.has(costCenter.id)}
        />
      )}
      renderSelectedItem={(costCenter) => (
        <EntityItem
          key={costCenter.id}
          onClick={() => {
            const s = new Set(selectedIds)
            s.delete(costCenter.id)
            onChange(s)
          }}
          primaryText={costCenter.name}
          removable={true}
        />
      )}
      selectedIds={selectedIds}
      useQuery={useCostCenters}
    />
  )
}
